import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import { createPinia } from 'pinia'

import { setupRouter } from './router' // ⬅️ gunakan named export
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

async function bootstrap() {
  const app = createApp(App)
  app.use(createPinia())

  const router = await setupRouter() // ⬅️ tunggu router selesai setup

  app.use(stores)
  app.use(router)
  app.use(i18n)
  app.use(createVuestic({ config: vuesticGlobalConfig }))

  if (import.meta.env.VITE_APP_GTM_ENABLED) {
    app.use(
      createGtm({
        id: import.meta.env.VITE_APP_GTM_KEY,
        debug: false,
        vueRouter: router,
      }),
    )
  }
  localStorage.setItem('routesInjected', 'false')
  sessionStorage.setItem('routesInjected', 'false')
  app.mount('#app')
}

bootstrap()
